export default class Services {

    getPosts = () => {
        return fetch('https://www.blogtorresdemeloneto.com.br/wp-json/wp/v2/posts?_embed=images,title,excerpt,link')
            .then(response => {
                if (!response.ok) {
                    throw response.json();                    
                }
                return response.json();
            });
    }
}